import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import type { UUID } from "@/Shared/types";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";

interface BranchesDropdownProps {
  branchId: UUID | undefined;
  setBranchId: (_: UUID | undefined) => void;
  branches: SavedLocation[];
}

function BranchesDropdown(props: BranchesDropdownProps) {
  const options = [
    // Magic string
    { value: "no_branch_assigned", label: "No branch assigned" },
    ...props.branches.map((t) => ({
      value: t.savedLocationId,
      label: t.location.businessName,
      group: "Branches",
    })),
  ];

  return (
    <Dropdown
      data-testid="branches-dropdown"
      value={props.branchId}
      onChange={props.setBranchId}
      options={options}
      placeholder="No branch assigned"
    />
  );
}

export default BranchesDropdown;
